<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
					<div class="modal-title">
						{{ modalTitle }}
					</div>
					<div class="modal-header__close-button" @click="closeModal">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
                </div>
				<div class="modal-body">
                    <table class="service-table table align-middle">
                        <thead>
                            <tr>
                                <th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
                                    <div class="th-inner sortable asc">
                                        <span style="width: 95%;">{{ elem }}</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="element in history" :key="element.id">
                                <td>{{ element.date }}</td>
                                <td>{{ element.time }}</td>
                                <td>{{ element.user }}</td>
                                <td>{{ element.action }}</td>
                            </tr>
                        </tbody>
                    </table>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ChangeHistoryModal",

    props: {
		modalTitle: {
			type: String,
			default: 'Title',
			Required: true
		},
		history: {
			type: Array,
			Required: true
		}
    },

    emits: "closeModal",

    data() {
        return {
            thead: ['Дата', 'Время', 'Пользователь', 'Действие']
        }
    },

    methods: {
        closeModal: function() {
            this.$emit('closeModal');
        },
    },
}
</script>

<style scoped>
    .modal-title {
        font-size: 18px;
    }
    .modal-body {
        max-height: 350px;
        overflow-y: auto;
    }
    .modal-body-element {
        padding: 6px 0px;
        display: flex;
        gap: 6px;
        font-size: 18px;
		color: #575F6E;
    }
    .col-header {
		font-size: 14px;
		font-weight: 600;
		color: #575F6E;
	}
</style>
